/**
 * Created by Administrador on 03/05/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('currencies', {
                parent: 'app',
                url: '/currency?page&size',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/finance/currency/currencies.html',
                        controller: 'currencyCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['currency']);
                            }],
                            currencies: ['currencyService','$stateParams', function(currencyService,$stateParams){
                                return currencyService.getPageCurrencies($stateParams.page, $stateParams.size);
                            }]
                        }
                    }
                }
            })
            .state('currencyNew', {
                parent: 'app',
                url: '/currency/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/finance/currency/newCurrency.html',
                        controller: 'newCurrencyCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['currency']);
                            }],
                            countries: ['countryService', function(countryService){
                                return countryService.getActiveCountries(true,false);
                            }],
                            currencies: ['currencyService', function(currencyService){
                                return currencyService.getCurrencies();
                            }]
                        }
                    }
                }
            })
            .state('currencyEdit', {
                parent: 'app',
                url: '/currency/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/finance/currency/editCurrency.html',
                        controller: 'editCurrencyCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['currency']);
                            }],
                            'currency': ['currencyService', '$stateParams', function(currencyService, $stateParams) {
                                return currencyService.getCurrency($stateParams.id);
                            }],
                            countries: ['countryService', function(countryService){
                                return countryService.getActiveCountries(true,false);
                            }],
                            currencies: ['currencyService', function(currencyService){
                                return currencyService.getCurrencies();
                            }]
                        }
                    }
                }
            })
            .state('currencyDelete', {
                parent: 'currencies',
                url: '/currency/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/finance/currency/deleteCurrency.html',
                        controller: 'deleteCurrencyController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['currency']);
                            }]
                        }
                    }).result.then(function() {
                        $state.go('currencies', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('currencyExchangeRates', {
                parent: 'app',
                url: '/currency/:id/exchangeRates',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/finance/currency/exchangeRatesCurrency.html',
                        controller: 'exchangeRateCurrencyController',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['currency']);
                            }],
                            'currency': ['currencyService', '$stateParams', function (currencyService, $stateParams) {
                                return currencyService.getCurrency($stateParams.id);
                            }],
                            'exchangeRates': ['exchangeRateService', '$stateParams', function (exchangeRateService, $stateParams) {
                                return exchangeRateService.getExchangeRateByCurrencyExchangeRate($stateParams.id);
                            }]
                        }
                    }
                }
            });
    }
})();
